// src/app/process-payment/process-payment.component.ts
import { Component, effect, inject, ViewChild, ElementRef, OnInit, AfterViewInit, OnChanges, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientEngagementService } from '../../services/patient-engagement.service';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { SignatureSource, SignatureType } from '../../../SecurePatientCommunication/models/chat.enum';
import { FormBuilder, FormGroup } from '@angular/forms';
import { StateService } from '../../services/history.state.service';
import { constant } from '../../../../constants/app.constants';
type Card = { id: string; brand: string; last4: string; exp: string; isDefault?: boolean };

@Component({
  selector: 'app-process-payment',
  templateUrl: './process-payment.component.html',
  styleUrls: ['./process-payment.component.css']
})
export class ProcessPaymentComponent {
  //  total = 7.70;
  elinkParams: any;
  selectedCardId: any;
  CardsDetails: any;
  openPaymentMethods: boolean = false;
  wpLoading: any;
  worldpayUrl: any;
  showWorldpay: any;
  selectedTransDetails: any;
  zeroCopay: any;
  metaData: any;
  signatureDataUrl?: string;
  hasSignature = false;
  signatureList: any;
errorMessage: string = '';
showErrorPopup: boolean = false;
showEdit = false;
currentCard: any = null;
editFG!: FormGroup;
  initialCardValues: { nickname: string; month: number | null; year: number | null } = {
    nickname: '',
    month: null,
    year: null
  };
  showRemovePopup = false;
  selectedCard: any = null;
months: string[] = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'));
years:  number[] = Array.from({ length: 21 }, (_, i) => 2025 + i);
showMonthDropdown = false;
showYearDropdown = false;
  localToUtcFormat: string | undefined;
  constructor(private _peService: PatientEngagementService,  private _router: Router,private sanitizer: DomSanitizer, private fb: FormBuilder,private stateService: StateService,private route: ActivatedRoute) {
  }
  ngOnInit() {
      this.stateService.worldpayActive$.subscribe(isActive => {
    this.showWorldpay = isActive;
    if (!isActive) {
      this.worldpayUrl = null;
    }
  });
     const nav = this._router.getCurrentNavigation();
     if (nav?.extras?.state?.payload) {
      this.selectedTransDetails = nav.extras.state.payload['selectedTransDetails'];
      localStorage.setItem('selectedTransDetails', JSON.stringify(this.selectedTransDetails));
      this.zeroCopay = nav.extras.state.payload['zeroCopay'];
    }   
    const storedDetails = localStorage.getItem('selectedTransDetails');
    if (storedDetails && storedDetails !== 'undefined' && !this.selectedTransDetails) {
     this.selectedTransDetails = JSON.parse(storedDetails);
  }  
     this.route.queryParams.subscribe(params => {
    if (params['message']) {
      this.errorMessage = params['message'];
      this.showErrorPopup = true;
      this.closeWorldpay();
    }
  });
   this.metaData = JSON.parse(localStorage.getItem('MetaData') as string);
    this.displaySavedCardDetails(this.metaData?.pharmacyNpi, this.metaData?.patientId);
     this.editFG = this.fb.group({
    nickname: [''],
    month: [null as string | null],
    year:  [null as number | null],
  });
   this.localToUtcFormat = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    localStorage.setItem("copayValue", this.selectedTransDetails?.amount);
  }

displaySavedCardDetails(pharmacyNpi: string, patientId: string) {
  const payload = { PatientNo: patientId, NPINo: pharmacyNpi };

  this._peService.getSavedCardDetails(payload).subscribe(resp => {
    if (resp) {
      this.CardsDetails = resp?.cardsData ? resp.cardsData : [];

      if (this.CardsDetails.length) {
        const defaultCard = this.CardsDetails.find(
          (c: any) => c?.preferences === "true"
        );

        if (defaultCard) {
          this.selectedCardId = defaultCard;
        } else {
          this.selectedCardId = this.CardsDetails.reduce((latest: any, curr: any) => {
            return new Date(curr?.tokenDate || 0) > new Date(latest?.tokenDate || 0)
              ? curr
              : latest;
          }, this.CardsDetails[0]);
        }
      } else {
        this.selectedCardId = null;
      }
    }
  });
}

  cancel(){
   localStorage.removeItem('selectedTransDetails');
   this._router.navigate(['/revieworders']);
  }

   toMMYY(dateStr?: string): string {
    if (!dateStr) return '--/--';
    // Try to parse safely
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '--/--';
    const mm = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    const yy = (d.getUTCFullYear() % 100).toString().padStart(2, '0');
    return `${mm}/${yy}`;
  }

openPaymentMethodsPopup() {
  this.openPaymentMethods = true;
  setTimeout(() => {
    const el = document.querySelector('.pm-modal') as HTMLElement;
    el?.focus();
  });
}
  closePaymentMethodsPopup() {
  this.openPaymentMethods = false;
}

selectCard(c: any) {
  this.selectedCardId = c;
}

async confirmSelection() {
  await this.updateCard(true);
  this.closePaymentMethodsPopup();
}
onAddCard() {
  this.wpLoading = true;
  this.worldpayUrl = null;
  this.showWorldpay = true;
  const payload = this._peService.buildSetupSalePayload();
  this._peService.setUpTrans(payload).subscribe({
  next: (resp: any) => {
    if (resp?.paymentTransactionURL && resp?.transactionSetupID) {
        localStorage.setItem("paymentSignature",  JSON.stringify(this.signatureDataUrl));
      const fullUrl = resp.paymentTransactionURL + resp.transactionSetupID;
      this.worldpayUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
       this.stateService.setWorldpayActive(true); 
      localStorage.setItem("ResponseObject", JSON.stringify(resp));
      
    } else {
      this.stateService.setActiveSection('process-payment');
      this._router.navigate(['/process-payment'], {
        queryParams: { message: constant.trans_fialed_MSG }
      });
    }

    this.wpLoading = false;
  },
  error: () => {
    this.wpLoading = false;
    this.showWorldpay = false;
  }
  });
}

closeWorldpay(): void {
    this.stateService.setWorldpayActive(false);
  this.showWorldpay = false;
  this.worldpayUrl = null;
  this.wpLoading = false;
}

async processPayment(){
   this.localToUtcFormat = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  if (!this.hasSignature) { return; }
   const amount = Number(this.selectedTransDetails?.amount || 0).toFixed(2);
  const payload = {
    NpiNo:this.metaData?.pharmacyNpi,
    PatientNo:(this.metaData?.patientId).toString(),
     Amount: amount,
    TransId: this.selectedTransDetails?.transID,
    PaymentAccountID: this.selectedCardId?.token
  }
  this._peService.cardPayment(payload).subscribe(response=>{
    if(response?.expressResponseCode === "0"){
       const newSignature = {
        SignatureImageBase64: this.signatureDataUrl?.replace(/^data:image\/(png|jpeg);base64,/, ''),
        type: 'Patient',
        timestamp: new Date().toISOString(),
        transID: this.selectedTransDetails?.transID,
        npiNo: this.elinkParams?.npi,
        signatureSource: SignatureSource.MyPrimeRx,
        signatureType: SignatureType.Payment,
        SignatureDtTm: this.localToUtcFormat
      };
      const payload1 = {
        ...response,
        signatures: [
          ...(response.signatures || []),
          newSignature,
        ],
      };
      this._peService.saveSignatureandTransaction(payload1).subscribe(resp=>{
       if(resp?.data && resp?.result === 'SUCCESS'){
         this._router.navigate(['/payment-confirm'], { 
           state: {selectedCard: this.selectedCardId, approvalNum : response?.approvalNumber, transactionAmt: this.selectedTransDetails?.amount } 
         });
       }else{
        this._router.navigate(['/payment-confirm'], {
          state: { isError: true }
        });
       }
      })
    }else{
      this._router.navigate(['/payment-confirm'], {
        state: { isError: true }
      });
    }
  })
}

  onSignature(data: string | null) {
    if (data) {
      this.signatureDataUrl = data;
      this.hasSignature = true;
    } else {
      this.signatureDataUrl = undefined;
      this.hasSignature = false;
    }
  }



editForm = {
  nickname: '',
  month: null as number | null,
  year: null as number | null
};

openEdit(card: any) {
  this.currentCard = card;
  const nickname = card?.cardAlias ?? card?.nickname ?? '';
  let monthNum: number = card?.expMonth ?? null;
  let yearNum:  number = card?.expYear  ?? null;

  if (card?.expiryDate) {
    const d = new Date(card.expiryDate);
    if (!isNaN(d.getTime())) {
      monthNum = d.getUTCMonth() + 1;
      yearNum  = d.getUTCFullYear();
    } else {
      const parts = String(card.expiryDate).split(/[\/\-]/);
      if (parts.length >= 2) {
        const mm = parseInt(parts[0], 10);
        const yy = parseInt(parts[1], 10);
        if (!isNaN(mm)) monthNum = mm;
        if (!isNaN(yy)) yearNum = yy < 100 ? 2000 + yy : yy;
      }
    }
  }
   const month: string | null = monthNum != null ? String(monthNum).padStart(2,'0') : null;// number or null
   const year:  number | null = yearNum ?? null;

  this.initialCardValues = { nickname, month: monthNum, year };
  this.showEdit = true;
  this.editFG.reset({ nickname, month, year }, { emitEvent: false });

}

closeEdit() {
  this.showEdit = false;
}

updateCard(isPref?: boolean) {
  if (this.editFG.invalid || !this.currentCard) return;
  const nickname: string = (this.editFG.value.nickname ?? '').trim();

  // Take month/year from form first
  let month: string | null = this.editFG.value.month;
  let yearFull: number | null = this.editFG.value.year;

  // If missing, fallback to expiryDate from currentCard
  if ((!month || !yearFull) && this.currentCard?.expiryDate) {
    const d = new Date(this.currentCard.expiryDate);
    if (!isNaN(d.getTime())) {
      month = String(d.getUTCMonth() + 1).padStart(2, '0'); // "02"
      yearFull = d.getUTCFullYear();                        // 2035
    }
  }

  // Always 2-digit year for API
  const yearYY: string | null =
    yearFull != null ? String(yearFull % 100).padStart(2, '0') : null;

  // Detect if user actually changed anything
  const expDateChanged =
    (month ?? null) !== (this.initialCardValues.month ?? null) ||
    (yearFull ?? null) !== (this.initialCardValues.year ?? null);

  const nicknameChanged =
    nickname !== (this.initialCardValues.nickname ?? '');

  const isExpDateUpdated = expDateChanged;
  const isOtherCardDetailsUpdated = expDateChanged || nicknameChanged || isPref;

  // Build payload
  const payload = {
    PatientNo: this.metaData?.patientId,
    NPINo: this.metaData?.pharmacyNpi,
    isExpDateUpdated,
    isOtherCardDetailsUpdated,
    CardAlias: isPref ? (this.currentCard?.nickname ?? nickname) : nickname || null,
    ExpirationMonth: isPref ? month : month,
    ExpirationYear: isPref ? yearYY : yearYY,
    CardType: this.currentCard?.cardType ?? this.currentCard?.brand ?? null,
    Last4: this.currentCard?.last4,
    Token: this.currentCard?.token,
    Processor: this.currentCard?.processor,
    EntryType: this.currentCard?.entryType,
    TokenDate: this.currentCard?.tokenDate,
    ExpiryDate: this.currentCard?.expiryDate,
    Preferences: isPref ? "true" : "false"
  };
  this._peService.updatePaymentCardDetails(payload).subscribe((resp: any) => {
    if (resp) {
      this.CardsDetails = resp?.cardsData ? resp.cardsData : [];
      this.selectedCardId = this.CardsDetails.find((c: { token: any; }) => c.token === this.currentCard?.token) || this.selectedCardId;
    }
    this.closeEdit();
  });
}


  openRemovePopup(card: any) {
    this.selectedCard = card;
    this.showRemovePopup = true;
  }

  closeRemovePopup() {
    this.showRemovePopup = false;
    this.selectedCard = null;
  }

removeCard(card: any) {
  const TokenDetails = [
    {
      PaymentAccountID: card?.token,
      CardType: card?.cardType,
      LastFour: card?.last4,
      EntryType: card?.entryType,
    },
  ];

  const payload = {
    PatientNo: String(this.metaData?.patientId),
    PharmacyNPI: String(this.metaData?.pharmacyNpi),
    TokenDetails: [TokenDetails[0]]
  };

  this._peService.deletePaymentCardDetails(payload).subscribe((resp: any) => {
    if (resp) {
      this.CardsDetails = resp?.cardsData ? resp.cardsData : [];
      if (this.CardsDetails.length) {
        const defaultCard = this.CardsDetails.find(
          (c: any) => c?.preferences === 'DEFAULT' || c?.preferences === true
        );

        if (defaultCard) {
          this.selectedCardId = defaultCard;
        } else if (
          !this.CardsDetails.some((c: { token: any; }) => c?.token === this.selectedCardId?.token)
        ) {
          this.selectedCardId = this.CardsDetails[0];
        }
      } else {
        this.selectedCardId = null;
        this.closePaymentMethodsPopup();
      }

      this.closeRemovePopup();
    }
  });

  this.closeRemovePopup();
}

onCloseErrorPopup() {
  this.showErrorPopup = false;
   this._router.navigate(['/dashboard']);
}

toggleDropdown(type: 'month' | 'year') {
  if (type === 'month') {
    this.showMonthDropdown = !this.showMonthDropdown;
    this.showYearDropdown = false; // close year if month opens
  } else {
    this.showYearDropdown = !this.showYearDropdown;
    this.showMonthDropdown = false; // close month if year opens
  }
}

// Close all when clicking outside
closeAllDropdowns() {
  this.showMonthDropdown = false;
  this.showYearDropdown = false;
}
}